import {SectionView} from './SectionView'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from './SpriteView'
import {TextView} from './TextView'
import {TranslationObject} from '@colonist/i18n'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {GameFont} from '../GameFont'

export class RibbonCountView extends SectionView {
    private readonly ribbonView: SpriteView
    private readonly countView: TextView

    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, largeRibbon: boolean) {
        const texture = largeRibbon ? UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ribbon_large) : UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ribbon_small)
        const removePadding = true
        super(x, y, w, h, container, removePadding)

        this.ribbonView = new SpriteView(0, 0, w, h, this, texture)
        this.ribbonView.centerXInParent()

        const count: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: 0}}
        const fontSize = GameFont.Size.Normal
        this.countView = new TextView(count, 0, 0, w, h, this, fontSize)
        this.countView.changeStyle({trim: false})
        this.countView.centerXInParent()
        this.countView.centerYInParent()
    }

    updateText(text: TranslationObject) {
        this.countView.setText(text)
        this.countView.centerXInParent()
    }
}
